/**
 * Analytics Event Names
 *
 * Centralized constants for all analytics events tracked on the website.
 * Use with `formatEventName()` to ensure consistent "Website - " prefix.
 *
 * @example
 * import { ANALYTICS_EVENTS, formatEventName } from '@/lib/analytics/analytics'
 *
 * track({
 *   eventType: formatEventName(ANALYTICS_EVENTS.LINK_CLICKED),
 *   eventProperties: { ... }
 * })
 */
export const ANALYTICS_EVENTS = {
  /** Fired when any link is clicked through AppLink component */
  LINK_CLICKED: 'Link Clicked',

  /** Fired when user switches between pricing plan tabs on mobile */
  PRICING_PLAN_TAB_CLICKED: 'Pricing Plan Tab Clicked',

  /** Fired when user toggles between monthly/yearly billing cycles */
  PRICING_BILLING_TOGGLED: 'Pricing Billing Toggled',

  /** Fired when the Intercom Messenger is opened (Intercom `onShow`) */
  INTERCOM_MESSENGER_OPENED: 'Intercom Messenger Opened',

  /** Fired when a visitor supplies their email in the Intercom Messenger (Intercom `onUserEmailSupplied`) */
  INTERCOM_EMAIL_SUPPLIED: 'Intercom Email Supplied',

  /** Fired when a visitor dismisses the announcement banner */
  ANNOUNCEMENT_DISMISSED: 'Announcement Dismissed',
} as const
